import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;

  & > img {
    width: auto;
    height: 70px;
  }
`

const ORGANIZATIONS = [
  {
    name: 'True Corporation',
    logo: '/tmp/courses/images/enterprise-react/organizations/true.jpg',
  },
  {
    name: 'Thairath',
    logo: '/tmp/courses/images/enterprise-react/organizations/thairath.png',
  },
  {
    name: 'โรงพยาบาลกล้วยน้ำไท',
    logo: '/tmp/courses/images/enterprise-react/organizations/กล้วยน้ำไท.png',
  },
  {
    name: 'Freewill',
    logo: '/tmp/courses/images/enterprise-react/organizations/freewill.jpg',
  },
  {
    name: 'DataWow',
    logo: '/tmp/courses/images/enterprise-react/organizations/datawow.png',
  },
  {
    name: 'Soilfish',
    logo: '/tmp/courses/images/enterprise-react/organizations/soilfish.png',
  },
]

export default function Organiztions() {
  return (
    <Wrapper>
      {ORGANIZATIONS.map((organization) => (
        <img
          key={organization.name}
          src={organization.logo}
          alt={organization.name}
        ></img>
      ))}
    </Wrapper>
  )
}
